import { Box } from '@mui/material';
import { styled } from '@mui/material/styles';
import { CellSingleValue } from './CellSingleValue';

const PREFIX = 'CellAddress';

const classes = {
  container: `${PREFIX}-container`,
};

type Address = {
  addressLine1: string;
  city: string;
  stateCode: string;
  zipCode: string;
};

const StyledCellAddress = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  gap: '4px',
  paddingLeft: '8px',
  fontFamily: 'Source Sans Pro',
  fontSize: '14px',
  fontWeight: 400,
  lineHeight: '20.02px',
  letterSpacing: '0.17px',
}));

type CellAddressProps = {
  address: Address;
};

const CellAddress = ({ address }: CellAddressProps) => {
  return (
    <StyledCellAddress className={classes.container}>
      <span>{address.addressLine1}</span>
      <span>{`${address.city}, ${address.stateCode} ${address.zipCode}`}</span>
    </StyledCellAddress>
  );
};

export { CellAddress };
export type { CellAddressProps };
